var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "problem" }, [
      _c("span", [_vm._v(_vm._s(_vm.seq))]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.name))]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm._f("formatType")(_vm.type)))])
    ]),
    _vm._v(" "),
    _vm.options.length > 0
      ? _c("div", { staticClass: "options" }, [
          _vm.type === "1"
            ? _c(
                "div",
                [
                  _c(
                    "van-radio-group",
                    {
                      staticClass: "option-line",
                      on: { change: _vm.checkOptions },
                      model: {
                        value: _vm.answer.optionId,
                        callback: function($$v) {
                          _vm.$set(_vm.answer, "optionId", $$v)
                        },
                        expression: "answer.optionId"
                      }
                    },
                    _vm._l(_vm.options, function(option) {
                      return _c(
                        "van-radio",
                        {
                          key: option.id,
                          staticClass: "option-item",
                          attrs: { name: option.id, "checked-color": "#e10913" }
                        },
                        [_vm._v(_vm._s(option.name))]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "2"
            ? _c(
                "div",
                [
                  _c(
                    "van-checkbox-group",
                    {
                      on: { change: _vm.checkOptions },
                      model: {
                        value: _vm.answer.optionId,
                        callback: function($$v) {
                          _vm.$set(_vm.answer, "optionId", $$v)
                        },
                        expression: "answer.optionId"
                      }
                    },
                    _vm._l(_vm.options, function(option) {
                      return _c(
                        "div",
                        { key: option.id, staticClass: "option-line" },
                        [
                          _c(
                            "van-checkbox",
                            {
                              staticClass: "option-item",
                              attrs: {
                                name: option.id,
                                "checked-color": "#e10913"
                              }
                            },
                            [_vm._v(_vm._s(option.name))]
                          )
                        ],
                        1
                      )
                    }),
                    0
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "3"
            ? _c("div", [
                _c("div", [
                  _vm.options[0].isContent === 1
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.options[0].optionContent,
                            expression: "options[0].optionContent"
                          }
                        ],
                        staticClass: "multiple-input",
                        attrs: { type: "text" },
                        domProps: { value: _vm.options[0].optionContent },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.options[0],
                              "optionContent",
                              $event.target.value
                            )
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.options[0].isContent === 2
                    ? _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.options[0].optionContent,
                            expression: "options[0].optionContent"
                          }
                        ],
                        staticClass: "multiple-textarea",
                        attrs: { type: "text" },
                        domProps: { value: _vm.options[0].optionContent },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.options[0],
                              "optionContent",
                              $event.target.value
                            )
                          }
                        }
                      })
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "4"
            ? _c(
                "div",
                [
                  _c(
                    "van-checkbox-group",
                    {
                      staticClass: "option-line",
                      on: { change: _vm.checkOptions },
                      model: {
                        value: _vm.answer.optionId,
                        callback: function($$v) {
                          _vm.$set(_vm.answer, "optionId", $$v)
                        },
                        expression: "answer.optionId"
                      }
                    },
                    _vm._l(_vm.options, function(option, index) {
                      return _c(
                        "div",
                        { key: option.id, staticClass: "option-item" },
                        [
                          _c(
                            "div",
                            { staticClass: "multiple-input-line" },
                            [
                              _c(
                                "van-checkbox",
                                {
                                  ref: "checkboxes",
                                  refInFor: true,
                                  attrs: {
                                    name: option.id,
                                    "checked-color": "#e10913"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(option.name) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              option.isContent === 1
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.options[index].optionContent,
                                        expression:
                                          "options[index].optionContent"
                                      }
                                    ],
                                    staticClass: "multiple-input",
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.options[index].optionContent
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.toggle(index)
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.options[index],
                                          "optionContent",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          option.isContent === 2
                            ? _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.options[index].optionContent,
                                    expression: "options[index].optionContent"
                                  }
                                ],
                                staticClass: "multiple-textarea",
                                attrs: { type: "text" },
                                domProps: {
                                  value: _vm.options[index].optionContent
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.toggle(index)
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.options[index],
                                      "optionContent",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            : _vm._e()
                        ]
                      )
                    }),
                    0
                  )
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9622d334", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9622d334","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/childCompoents/surveyProblem.vue
// module id = null
// module chunks = 